<template>
  <div class="psLine">
    <div :id="psLine"></div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
export default {
  name: 'psLine',
  props: {
    data: {
      required: true,
      type: Array
    },
    kind: {
      required: true,
      type: Array
    },
    msg: {
      required: false,
      type: String
    },
    inverse: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      // subtext: ''
    };
  },
  mounted() {
    this.chartLine = echarts.init(document.getElementById(this.psLine));
    this.initData();
    window.addEventListener('resize', this.chartLine.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartLine.resize);
  },
  methods: {
    initData() {
      let opt = {
        title: {
          text: this.msg || '',
          // subtext: this.subtext,
          x: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.kind,
          inverse:this.inverse
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '平均分',
            data: this.data,
            type: 'line',
            connectNulls: true
          }
        ]
      };

      this.chartLine.setOption(opt);
    }
  },
  computed: {
    psLine() {
      // id的唯一性   确保可重复使用echart的这个组件
      return 'line' + Math.random() * 100000;
    }
  },
  watch: {
    data: {
      handler() {
        this.initData();
      },
      deep: true
    },
    kind: {
      handler() {
        this.initData();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.psLine {
  width: 100%;
  height: 100%;
  > div {
    width: 100%;
    height: 100%;
  }
}
</style>
